import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-[#F7F5F0] text-[#1A2230]">
            <ScrollToTop />
            <Navbar />
            <main className="flex-1" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
            <Chatbot />
        </div>
    );
}
